<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><h1 class="part-number">Part 1</h1><p class="img"><img alt="art" src="images/Art_ptline.jpg"/></p>
<h1 class="part-title"><em>April 1996</em></h1></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?dcd0f616